import React from "react"
import DevTest from "../components/DevTest"
// Semi-permanent view for testing features and CSS changes
export default function DevTestView() {
  return <DevTest />
}
